// extracted by mini-css-extract-plugin
export var billingAddress = "_yb-g";
export var contactInfo = "_yb-d";
export var customerInfoContainer = "_yb-c";
export var customerInfoContainerMobile = "_yb-h";
export var customerInfoRow = "_yb-a";
export var customerInfoSection = "_yb-b";
export var fullWidthDividerMobile = "_yb-i";
export var imageContainer = "_yb-1";
export var paymentMethod = "_yb-e";
export var priceText = "_yb-6";
export var priceTextMobile = "_yb-7";
export var product = "_yb-0";
export var productImage = "_yb-2";
export var productInfo = "_yb-4";
export var productMobile = "_yb-9";
export var productTitle = "_yb-8";
export var quantityBadge = "_yb-3";
export var quantityText = "_yb-5";
export var shippingAddress = "_yb-f";